import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ArchivoCargueAdminInfI } from 'src/app/modelos/ArchivoCargueAdminInf';
import { DeptoI } from 'src/app/modelos/departamento.interface';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { OperacionI } from 'src/app/modelos/operacionEsta.interface';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { ResCargueExcelAdminInfI } from 'src/app/modelos/ResCargueExcelAdminInf';
import { ResponseCargueI } from 'src/app/modelos/ResponseCargue';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-cargueminformchv',
  templateUrl: './cargueminformchv.component.html',
  styleUrls: ['./cargueminformchv.component.css']
})
export class CargueminformchvComponent implements OnDestroy,OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  Operacion : OperacionI = new OperacionI;
  fuentesChv : fuenteI[];
  FuenteCargueM : fuenteI = new fuenteI;
  Depto : DeptoI = new DeptoI;
  Muni : DivipolaI = new DivipolaI;
  PeriodosConsultar : PeriodoReporteI[];
  PeriodoCargueMasivo : PeriodoReporteI = new PeriodoReporteI;
  file: any;
  contenidoDocumento: string = "";
  ArchivoCargueMasivo : ArchivoCargueAdminInfI = new ArchivoCargueAdminInfI;
  ArchivoCargueMasivoSuper : ArchivoCargueAdminInfI = new ArchivoCargueAdminInfI;
  FechaHoy : Date = new Date();
  RespuestaCargue : ResponseCargueI = new ResponseCargueI;
  EstadoInfomacionFuente : EstadoInfoChvI = new EstadoInfoChvI;
  ObservacionCargue : String;

  BtnCargarArchivo : Boolean;
  CargueExitoso : Boolean;
  ErrorCargue : Boolean;
  BtnConfirmarCargue : Boolean;
  BtnCargarArchivoSuper : Boolean;
  CargueExitosoSuper : Boolean;
  ErrorCargueSuper : Boolean = false;
  BtnConfirmarCargueSuper : Boolean;

  @ViewChild('OpenModalCargueMasivo') OpenModalCargueMasivo: ElementRef;
  @ViewChild('CloseModalCargueMasivo') CloseModalCargueMasivo: ElementRef;
  @ViewChild('OpenModalCargueMasivoSuper') OpenModalCargueMasivoSuper: ElementRef;
  @ViewChild('CloseModalCargueMasivoSuper') CloseModalCargueMasivoSuper: ElementRef;

  pdfUrl: string = 'assets/Formatos/Guia diligenciamiento_CHV.pdf';
  xlsxUrl: string = 'assets/Formatos/Plantilla CHV Fuentes.xlsx';
  xlsxUrlSuper: string = 'assets/Formatos/Plantilla CHV Supersolidaria.xlsx';

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService
  ) { }

  ngOnInit(): void {
    this.initializeDataTableOptions();

    this.BtnCargarArchivo = false;
    this.CargueExitoso = false;
    this.ErrorCargue = false;
    this.BtnConfirmarCargue = false;

    this.Operacion.id =1;
    this.Operacion.descripcion= "Cartera Hipotecaria de Vivienda";
    this.Operacion.nombre = "CHV";
    this.api.getFuentesByOpe(this.Operacion).subscribe(data=>{
      this.dtTrigger.next();
      this.fuentesChv = data;
      for (let fte of this.fuentesChv){
        this.api.getdeptoByCod(fte.depto).subscribe(depto0=>{
          this.Depto = depto0;
          fte.depto = this.Depto.nombre;
        });
        this.api.getMuniByCodigo(fte.muni).subscribe(muni0=>{
          this.Muni = muni0;
          fte.muni = this.Muni.nommpio;
        });
      }
    });
  }

  initializeDataTableOptions(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language: {
        processing: 'Procesando...',
        lengthMenu: 'Mostrar _MENU_ registros',
        zeroRecords: 'No se encontraron resultados',
        emptyTable: 'Ningún dato disponible en esta tabla',
        infoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
        infoFiltered: '(filtrado de un total de _MAX_ registros)',
        search: 'Buscar:',
        loadingRecords: 'Cargando...',
        paginate: {
          first: 'Primero',
          last: 'Último',
          next: 'Siguiente',
          previous: 'Anterior'
        },
        aria: {
          sortAscending: ': Activar para ordenar la columna de manera ascendente',
          sortDescending: ': Activar para ordenar la columna de manera descendente'
        },
        info: 'Mostrando de _START_ a _END_ de _TOTAL_ estados'
      }
    };
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminChv(){
    this.router.navigate(['admininfochv']);
  }

  RealizarCargueMasivo(idFte){
    this.OpenModalCargueMasivo.nativeElement.click();
    this.ObservacionCargue = "";
    this.BtnCargarArchivo = true;
    this.CargueExitoso = false;
    this.ErrorCargue = false;
    this.BtnConfirmarCargue = false;
    this.api.getFuenteById(idFte).subscribe(result1=>{
      this.FuenteCargueM = result1;
      this.api.listaPeriodosCalendario().subscribe(result2=>{
        this.PeriodosConsultar = result2;
      });
    });
  }

  ConsultarExisteReporte(idPeri){
    this.api.ConsultaReportoPeriodo(this.FuenteCargueM.id, idPeri).subscribe(result3=>{
      if(result3){
        this.BtnCargarArchivo = false;
        this.api.PeriodoPorId(idPeri).subscribe(result4=>{
          this.PeriodoCargueMasivo = result4;
          this.api.EstadoInfParaFuente(result4.id, this.FuenteCargueM.id).subscribe(result6=>{
            this.EstadoInfomacionFuente = result6;
          });
        });
      } else {
        this.BtnCargarArchivo = true;
        this.toastr.warning('Existe información registrada para el periodo seleccionado.', 'Advertencia!');
      }
    });
  }

  public uploadFile(event){
    this.BtnCargarArchivo = false;
    this.CargueExitoso = false;
    this.ErrorCargue = false;
    this.BtnConfirmarCargue = false;
    this.BtnCargarArchivoSuper = false;
    this.CargueExitosoSuper = false;
    this.ErrorCargueSuper = false;
    this.BtnConfirmarCargueSuper = false;
    this.file = (event.target as HTMLInputElement).files[0];
    if(this.file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      this.file.type=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      this.file.type=='application/vnd.ms-excel'){
    }else{
      this.toastr.error('Solamente se permiten archivos tipo EXCEL.', 'Error!');
      return;
    }
    let comp = this;
    let reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = function () {
          comp.contenidoDocumento = reader.result.toString();
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
          return error;
        };
  }

  VerificarDocumentoCargue(){
    this.BtnCargarArchivo = true;

    if(this.PeriodoCargueMasivo.id == undefined || this.PeriodoCargueMasivo.id == null){
      this.toastr.warning('Seleccione un periodo.', 'Advertencia!');
      this.BtnCargarArchivo = false;
    }else if(this.contenidoDocumento == undefined || this.contenidoDocumento == null || this.contenidoDocumento == ""){
      this.toastr.warning('Debe cargar un archivo.', 'Advertencia!');
      this.BtnCargarArchivo = false;
    }else{
      this.ArchivoCargueMasivo.nombre = this.file.name;
      this.ArchivoCargueMasivo.comentario = "";
      this.ArchivoCargueMasivo.tipo = this.file.type;
      this.ArchivoCargueMasivo.fechaCarga = this.FechaHoy.getDate() +"/"+ (this.FechaHoy.getMonth()+1) +"/"+ this.FechaHoy.getFullYear();
      this.ArchivoCargueMasivo.rutaArch = "";
      this.ArchivoCargueMasivo.contenido = this.contenidoDocumento;
      this.ArchivoCargueMasivo.idUsuarioCarga = +localStorage.getItem('id');
      this.ArchivoCargueMasivo.idFuente = this.FuenteCargueM.id;
      this.ArchivoCargueMasivo.idPeriodo = this.PeriodoCargueMasivo.id;

      this.api.VerificarContenidoDocumento(this.ArchivoCargueMasivo).subscribe(result5=>{
        this.RespuestaCargue = result5;
        if(result5.estado == "ERROR"){
          this.BtnCargarArchivo = true;
          this.CargueExitoso = false;
          this.ErrorCargue = true;
          this.BtnConfirmarCargue = false;
        }
        if(result5.estado == "ERRORVACIO"){
          this.toastr.error('Archivo sin contenido.', 'Error!');
          this.BtnCargarArchivo = true;
          this.CargueExitoso = false;
          this.ErrorCargue = false;
          this.BtnConfirmarCargue = false;
        }
        if(result5.estado == "OK"){
          this.BtnCargarArchivo = true;
          this.CargueExitoso = true;
          this.ErrorCargue = false;
          this.BtnConfirmarCargue = false;
        }
      });
    }
  }

  download(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById("ErroresCargue"));
    XLSX.utils.book_append_sheet(workbook, ws1, "ErroresCargue");
    XLSX.writeFile(workbook, "Errores_Cargue_"+this.FuenteCargueM.codEnti+".xlsx");
  }

  ConfirmarCargue(){
    this.BtnConfirmarCargue = true;
    if(this.ObservacionCargue == "" || this.ObservacionCargue == null || this.ObservacionCargue.length == 0){
      this.toastr.warning('Ingresar observación.', 'Advertencia!');
      this.BtnConfirmarCargue = false;
    }else if(this.ObservacionCargue.length < 20 ){
      this.toastr.warning('Observación debe tener mínimo 20 caracteres.', 'Advertencia!');
      this.BtnConfirmarCargue = false;
    }else if(this.ObservacionCargue.length > 500 ){
      this.toastr.warning('Observación debe tener máximo 500 caracteres.', 'Advertencia!');
      this.BtnConfirmarCargue = false;
    }else {
      this.api.CargueConfirmacionChv(this.ArchivoCargueMasivo).subscribe(result7=>{
        this.EstadoInfomacionFuente.estado = "Cargado";
        this.EstadoInfomacionFuente.novedadSis = "99 - Rinde / Novedad reportada";
        this.EstadoInfomacionFuente.observacionSis = this.ObservacionCargue;
        if(result7.estado == "OK"){
          this.api.CambiarEstadoInformacionChv(this.EstadoInfomacionFuente, localStorage.getItem('usuario')).subscribe(result8=>{
            if(result8){
              this.toastr.success('Cargue confirmado.', 'OK!');
              this.CloseModalCargueMasivo.nativeElement.click();
              window.location.reload();
            }
          }, error=>{
            this.toastr.error('No se guardó.', 'Error!');
            this.CloseModalCargueMasivo.nativeElement.click();
          });
        }
      });
    }
  }

  CerrarModalCargueFuente(){
    if(this.CargueExitoso){
      this.toastr.warning('Debe confirmar el cargue.', 'Advertencia!');
    } else {
      this.CloseModalCargueMasivo.nativeElement.click();
    }
  }

  RealizarCargueMasivoSupersolidaria(){
    this.OpenModalCargueMasivoSuper.nativeElement.click();
    this.BtnCargarArchivoSuper = true;
    this.CargueExitosoSuper = false;
    this.ErrorCargueSuper = false;
    this.BtnConfirmarCargueSuper = false;
    this.api.listaPeriodosCalendario().subscribe(result9=>{
      this.PeriodosConsultar = result9;
    });
  }

  ConsultarExisteReporteSuper(idPeri){
    this.api.ConsultaSupersoliPuedeReportarPeriodo(idPeri).subscribe(result10=>{
      if(result10){
        this.BtnCargarArchivoSuper = false;
        this.api.PeriodoPorId(idPeri).subscribe(result11=>{
          this.PeriodoCargueMasivo = result11;
        })
      } else {
        this.toastr.warning('Todas las fuentes reportaron.', 'Advertencia!');
        this.BtnCargarArchivoSuper = true;
      }
    });
  }

  VerificarDocumentoCargueSuper(){
    this.BtnCargarArchivoSuper = true;
    this.ArchivoCargueMasivoSuper.nombre = this.file.name;
    this.ArchivoCargueMasivoSuper.comentario = "";
    this.ArchivoCargueMasivoSuper.tipo = this.file.type;
    this.ArchivoCargueMasivoSuper.fechaCarga = this.FechaHoy.getDate() +"/"+ (this.FechaHoy.getMonth()+1) +"/"+ this.FechaHoy.getFullYear();
    this.ArchivoCargueMasivoSuper.rutaArch = "";
    this.ArchivoCargueMasivoSuper.contenido = this.contenidoDocumento;
    this.ArchivoCargueMasivoSuper.idUsuarioCarga = +localStorage.getItem('id');
    this.ArchivoCargueMasivoSuper.idPeriodo = this.PeriodoCargueMasivo.id;
    this.api.VerificarContenidoDocumentoSupersoliChv(this.ArchivoCargueMasivoSuper).subscribe(result11=>{
      this.RespuestaCargue = result11;
      if(result11.estado == "ERROR"){
        this.BtnCargarArchivoSuper = true;
        this.CargueExitosoSuper = false;
        this.ErrorCargueSuper = true;
        this.BtnConfirmarCargueSuper = false;
      }
      if(result11.estado == "ERRORVACIO"){
        this.toastr.error('Archivo sin contenido.', 'Error!');
        this.BtnCargarArchivo = true;
        this.CargueExitoso = false;
        this.ErrorCargue = false;
        this.BtnConfirmarCargue = false;
      }
      if(result11.estado == "OK"){
        this.BtnCargarArchivoSuper = true;
        this.CargueExitosoSuper = true;
        this.ErrorCargueSuper = false;
        this.BtnConfirmarCargueSuper = false;
      }
    });
  }

  download2(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById("ErroresCargueSuper"));
    XLSX.utils.book_append_sheet(workbook, ws1, "ErroresCargue");
    XLSX.writeFile(workbook, "Errores_Cargue_Supersolidaria.xlsx");
  }

  ConfirmarCargueSuper(){
    //this.BtnConfirmarCargueSuper = true;
    this.api.CargueConfirmacioSupersolinChv(this.ArchivoCargueMasivoSuper).subscribe(result12=>{
      if(result12.estado == "OK"){
        this.toastr.success('Cargue confirmado.', 'OK!');
        this.CloseModalCargueMasivoSuper.nativeElement.click();
      }
    }, error=>{
      this.toastr.error('No se guardó.', 'Error!');
      //this.CloseModalCargueMasivoSuper.nativeElement.click();
    });
  }


  exportarExcel(idTabla:string){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById(idTabla));
    XLSX.utils.book_append_sheet(workbook, ws1, idTabla);
    XLSX.writeFile(workbook, idTabla+".xlsx");
  }











}
